import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as XLSX from 'xlsx';

export interface ParsedFile {
  id?: string;
  fileName: string;
  headers: string[];
  preview: any[];
  mappedColumns: { [key: string]: string };
  rawFile?: File;
}

@Component({
  selector: 'egi-file-parser',
  templateUrl: './egi-file-parser.component.html',
  styleUrls: ['./egi-file-parser.component.css'],
})
export class EgiFileParserComponent implements OnInit {
  @Input() fieldsToMap: string[] = [];
  @Input() disabled: boolean = false;
  @Input() file: ParsedFile;

  @Output() fileChange = new EventEmitter<ParsedFile>();

  ngOnInit(): void {
    if (!this.file) {
      this.file = {
        fileName: '',
        headers: [],
        preview: [],
        mappedColumns: {},
      };
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selectedFile = input?.files?.[0];

    if (!selectedFile) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length) {
        const headers = jsonData[0] as string[];
        const preview = jsonData.slice(1, 6).map((row: any[]) => {
          const rowObj: any = {};
          headers.forEach((header, i) => (rowObj[header] = row[i]));
          return rowObj;
        });

        this.file = {
          ...this.file,
          fileName: selectedFile.name,
          headers,
          preview,
          mappedColumns: {},
          rawFile: selectedFile, // optional
        };

        this.emitFile();
      }
    };

    reader.readAsArrayBuffer(selectedFile);
  }

  onMappingChange(): void {
    this.emitFile();
  }

  private emitFile(): void {
    this.fileChange.emit(this.file);
  }
}
